import Head from 'next/head';

import {HeadSEO} from '@udemy/head-seo';
import {useI18n} from '@udemy/i18n';

import {getLayout} from 'src/components/layout';
import {FreeCategory} from 'src/features/category/components/free/free-category.react-component';
import {useSetupNavigation} from 'src/hooks/use-setup-navigation';
import {useCanonicalUrl} from 'src/hooks/useCanonicalUrl';
import {META_DEFAULT_BASE_URL} from 'src/lib/constants';
import {PageProps} from 'src/types/page-props';

import {FreeCategoryProps} from './types';

export type FreeCategoryPageProps = FreeCategoryProps & PageProps;

export const FreeCategoryPage = (props: FreeCategoryPageProps) => {
    const {gettext, interpolate} = useI18n();
    const {url: canonicalUrl} = useCanonicalUrl(['p'], META_DEFAULT_BASE_URL);
    useSetupNavigation();

    const currentYear = new Date().getFullYear();
    const title = interpolate(
        gettext(
            '450+ Free Online Courses - Best of %(currentYear)s | Udemy Learning and Certification',
        ),
        {currentYear},
        true,
    );
    const description = gettext(
        'Learn Python, Excel, digital marketing, HTML, JavaScript & more with 450+ free courses. Udemy offers certificates from industry professionals.',
    );

    return (
        <>
            <HeadSEO
                title={title}
                ogTitle={title}
                description={description}
                ogDescription={description}
                ogType="video_lecture"
                ogLocale={process.env.I18N_PATH_TO_BUNDLE_MAP[props.locale]}
                canonicalUrl={canonicalUrl}
                assetPath={process.env.ASSET_PREFIX}
                headWrapper={Head}
            />
            <FreeCategory {...props} />
        </>
    );
};

FreeCategoryPage.getLayout = getLayout;
